import { Dispatch } from "redux";
import ProductAdaptee from "../../../adapters/product/ProductAdaptee";
import ProductAdapter from "../../../adapters/product/ProductAdapter";
import { IProductPrepared } from "../../../entities/product/types";
import BusinessRuleFacade from "../../../rules/BusinessRuleFacade";
import { getItemFromSessionStorage } from "../../../utilites/localStorage";
import { addSelectedProductsToBundle } from "../../../utilites/preBasketUtilities";
import Validator from "../../../validators/Validator";
import { AppState } from "../rootReducers";
import { setEditMode, setPreBasketProductData, setPreBasketProducts } from "./actions";

abstract class IPreBasketMiddlewareProxy {

  public static setPreBasketInSessionStorage: (state: AppState, next: Dispatch) => void;
  public static setEditModeInSessionStorage: (state: AppState, next: Dispatch, payload: any) => void;
  public static clearPreBasket: (next: Dispatch) => void;
  public static removePreBasketProduct: (state: AppState, next: Dispatch, payload: any) => void;
  public static getPreBasket: (state: AppState, next: Dispatch) => void;

}

export default class PreBasketProductsMiddlewareProxy extends IPreBasketMiddlewareProxy {

  public static setPreBasketInSessionStorage(state: AppState, next: Dispatch): void {
    const productCopy =  { ...state.productData.product.item };
    const colorIdFromProductData = state.productData.productData.color;
    const productDataCopy = { ...state.productData.productData };
    const productAdaptee = (new ProductAdapter(productCopy, new ProductAdaptee())).transform();
    productAdaptee.productColorsImages.colors = productAdaptee.productColorsImages?.colors?.filter((color: any) => color.id === colorIdFromProductData);
    const products = getItemFromSessionStorage('preBasketProducts', '[]');
    const productData = getItemFromSessionStorage('preBasketProductData', '{}');
    const businessRuleFacade = BusinessRuleFacade.getInstance();
    businessRuleFacade.init(productCopy, {});

    // any number of tv or cordlessPhone can be added
    if (businessRuleFacade.isTvOrCordlessPhoneOrStb()) {
      products.push(productAdaptee);
      sessionStorage.setItem("preBasketProducts", JSON.stringify(products));
    }

    if (Validator.isUndefined(productData) || !Validator.checkIfObjectHasPropKeys(productData)) {
      sessionStorage.setItem("preBasketProductData", JSON.stringify(productDataCopy));
      next(setPreBasketProductData(productDataCopy));
    }
    addSelectedProductsToBundle(products, state, next);
    next(setPreBasketProducts(products));
  }

  public static setEditModeInSessionStorage(state: AppState, next: Dispatch, payload: any): void {
    const currentEditMode = state.preBasket.editMode;
    if (currentEditMode !== payload.editMode) {
      sessionStorage.setItem("editMode", payload.editMode);
      next(setEditMode(payload.editMode));
    }
  }

  public static clearPreBasket(next: Dispatch): void {
    sessionStorage.setItem("preBasketProducts", '[]');
    next(setPreBasketProducts([]));
    sessionStorage.setItem("preBasketProductData", '{}');
    next(setPreBasketProductData({}));
    sessionStorage.setItem("editMode", 'false');
    next(setEditMode(false));
  }

  public static removePreBasketProduct(state: AppState, next: Dispatch, payload: { productId: number }): void {
    const prebasketProducts = state.preBasket.products;
    const foundIndex = prebasketProducts.findIndex((product: any) => product.id === payload.productId);
    const filteredProducts = prebasketProducts.filter((_:any, index: number) => index !== foundIndex);
    sessionStorage.setItem("preBasketProducts", JSON.stringify(filteredProducts));
    next(setPreBasketProducts(filteredProducts));
    addSelectedProductsToBundle(filteredProducts as IProductPrepared[], state, next);
  }

  public static getPreBasket(state: AppState, next: Dispatch): void {
    const sessionStorageProducts = getItemFromSessionStorage('preBasketProducts', '[]');
    const sessionStorageProductData = getItemFromSessionStorage('preBasketProductData', '{}');
    const sessionStorageEditMode = getItemFromSessionStorage('editMode', 'false');

    if (sessionStorageProducts.length > 0) {
      next(setPreBasketProducts(sessionStorageProducts));
      addSelectedProductsToBundle(sessionStorageProducts, state, next);
    }

    if (Validator.checkIfObjectHasPropKeys(sessionStorageProductData)) {
      next(setPreBasketProductData(sessionStorageProductData));
    }

    next(setEditMode(sessionStorageEditMode));
  }

}
